import React, { FC, useState } from 'react'
import { Button, Table, Input, message, Upload } from 'antd'
import { YhBox } from '@/components/YhBox'
import { ColumnsType } from 'antd/es/table'
import { RouterParamType } from '@/model/navModel'
import { EditableRow, EditableCell, Item } from '@/components/YHEditTable/editTable'

import {  IImportInquiryGoods, IInquiryGoods, IInquiryGoodsDetail } from '../../inquiryTypes'
import { useInquiryDetailsMode } from './inquiryDetailsModel'
import { formatNum, generateUniqueId } from '@/utils/utils'
import { importPropsConfig } from '@/utils/importFile'
import useGlobalModel from '@/model/globalModel'

export const TableBox: FC<RouterParamType> = ({ id, mode }) => {
    const {setLoadingInfo} = useGlobalModel()
    const { addGoodsList, setAddGoodsList, editGoodsList, setEditGoodsList, setAddGoodsModal, downloadGoodsTemplate } = useInquiryDetailsMode()

    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([])

    const handleAddGoods = () => {
        setAddGoodsModal(true)
    }

    const handleRemoveGoods = () => {
        let dataSource = mode === 'edit' ? editGoodsList : addGoodsList
        if (!selectedRowKeys.length) {
            message.warning('请选择你要删除的商品')
            return
        }
        mode === 'edit'
            ? setEditGoodsList((origin) => origin.filter((item) => selectedRowKeys.indexOf(item.id) < 0))
            : setAddGoodsList((origin) => origin.filter((item) => selectedRowKeys.indexOf(item.id) < 0))

        let newSearchData = dataSource.filter((item) => selectedRowKeys.indexOf(item.id) < 0)
        mode === 'edit' ? setEditGoodsList([...newSearchData]) : setAddGoodsList([...newSearchData])
        setSelectedRowKeys([])
        message.success('删除成功')
    }

    const upLoadCallback = (value: IImportInquiryGoods | undefined) => {
        let dataSource = mode === 'edit' ? [...editGoodsList] : [...addGoodsList]
        if(value) {
            const {list, msg} = value
            list.forEach(item => {
                if(dataSource.findIndex(i => i.materialCode === item.materialCode) === -1){
                    dataSource.push({
                        ...item,
                        id: generateUniqueId()
                    })
                }
                
            })
            mode === 'edit' ? setEditGoodsList(dataSource) : setAddGoodsList(dataSource)
            message.success(msg)
        }
        //不管导入成功与否， 将全局loading恢复初始值。
        setLoadingInfo({ loadingVisible: false, txt: "" });
    }


    const action = (
        <div>
            <Button className="mr-5" type="link" shape="round" onClick={handleAddGoods}>
                新增商品
            </Button>
            <Button className="mr-5" type="link" shape="round" onClick={handleRemoveGoods}>
                删除商品
            </Button>
            <Upload
                showUploadList={false}
                className="mr-10 ml-10"
                {...importPropsConfig(`/sum/inquiry/import`, upLoadCallback, () => setLoadingInfo({ loadingVisible: true, txt: '快速导入中' }))}
            >
                <Button className="mr-5" type="link" shape="round">
                    导入
                </Button>
            </Upload>
            <Button className="mr-5" type="link" shape="round" onClick={downloadGoodsTemplate}>
                下载模版
            </Button>
        </div>
    )

    const columns = [
        {
            title: '序号',
            width: 40,
            fixed: 'left',
            align: 'center',
            render: (t: any, r: any, i: number) => i + 1,
        },
        {
            title: '商品编号',
            width: 140,
            align: 'left',
            dataIndex: 'materialCode',
        },
        {
            title: '商品名称',
            width: 140,
            align: 'left',
            dataIndex: 'materialName',
        },
        {
            title: '品牌',
            width: 140,
            align: 'left',
            dataIndex: 'brandName',
            editable:true
        },
        {
            title: '规格',
            width: 140,
            align: 'left',
            dataIndex: 'model',
            editable:true
        },
        {
            title: '单位',
            width: 140,
            align: 'left',
            dataIndex: 'unitName',
            editable:true
        },
        {
            title: '单价',
            width: 140,
            align: 'left',
            dataIndex: 'price',
            editable:true,
            rules: [
                {
                    required: true,
                    message: '输入不能为空!',
                },
                {
                    pattern: /^(0|[1-9]\d*)(\.\d+)?$/, // 正数的正则表达式
                    message: '必须为正数!',
                },
            ],
        },
        {
            title: '备注',
            width: 140,
            align: 'left',
            dataIndex: 'note',
        },
    ]

    const newSelectColumns = columns.map((col: any, index) => {
        return {
            ...col,
            onCell: (record: IInquiryGoodsDetail, rowIndex: number) => {
                return {
                    colIndex: index + 1,
                    rowIndex,
                    record,
                    rules: col?.rules,
                    options: col?.options,
                    editType: col?.editType,
                    editable: col?.editable,
                    onSelectChange: col?.onSelectChange,
                    onSelectFocus: col?.onSelectFocus,
                    onSelectSearch: col?.onSelectSearch,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: handleSave,
                }
            },
        }
    })
    //内联编辑
    const handleSave = (row: IInquiryGoods) => {
        row.price = +formatNum(row.price)
        if(row.price === 0){
            row.price = ''
            message.error("单价必须为大于 0 的正数!")
        }
        let dataSource = mode === 'edit' ? editGoodsList : addGoodsList
        const index = dataSource.findIndex((item) => row.id === item.id)
        const item = dataSource[index]
        dataSource.splice(index, 1, { ...item, ...row })
        mode === 'edit' ? setEditGoodsList([...dataSource]) : setAddGoodsList([...dataSource])
    }
    return (
        <YhBox title="" action={action} style={{ marginBottom: '75px', height: 'calc(100vh - 720px)', minHeight: '600px' }}>
            <Table
                rowKey={(record) => record.id}
                rowClassName="editable-row yh-edit-table-tr"
                rowSelection={{
                    selectedRowKeys: selectedRowKeys, //记录选中
                    onChange: (selectedRowKeys: React.Key[], selectedRows: IInquiryGoods[]) => {
                        setSelectedRowKeys(selectedRowKeys as string[])
                    },
                }}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                columns={newSelectColumns as ColumnsType<IInquiryGoods>}
                dataSource={mode === 'edit' ? editGoodsList : addGoodsList}
                pagination={false}
                scroll={{ x: 'max-content', y: '400px' }}
            />
        </YhBox>
    )
}
